import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "@/components/motion";
import { img } from "@/lib/gallery";

export const Intro = () => {
  const { t } = useI18n();
  const i = t.intro;
  const dims = [[i.l, "3 850"], [i.w, "2 200"], [i.h, "2 200"]];
  return (
    <section className="relative bg-[var(--night)] py-24 lg:py-36" data-testid="intro-section">
      <div className="container-x">
        <div className="grid gap-10 lg:grid-cols-12">
          <SectionHead index="01" eyebrow={i.eyebrow} title={i.title} className="lg:col-span-7" />
          <Reveal delay={0.1} className="lg:col-span-5 lg:pt-10">
            <p className="text-base leading-relaxed text-[var(--steel)] md:text-lg">{i.text}</p>
          </Reveal>
        </div>
        <div className="chamfer relative mt-16 aspect-[16/10] overflow-hidden sm:aspect-[21/9]">
          <img src={img(4)} alt="MB300 ouvert" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#070C1A]/80 via-transparent to-transparent" />
          <p className="absolute bottom-5 left-6 font-mono text-[11px] uppercase tracking-[0.2em] text-white/90">MB300 — {t.hero.dims}</p>
        </div>
        <div className="mt-12 grid gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--gold)]">{i.dimsTitle}</p>
            <div className="mt-5 grid grid-cols-3 border-y border-white/12" data-testid="intro-dimensions">
              {dims.map(([l, v], k) => (
                <div key={l} className={`py-6 ${k ? "border-l border-white/12 pl-4 sm:pl-6" : ""}`}>
                  <p className="text-xs uppercase tracking-[0.14em] text-[var(--steel-dim)]">{l}</p>
                  <p className="font-display mt-1 text-3xl font-black sm:text-5xl">{v}<span className="ml-1 text-sm font-bold text-[var(--steel-dim)]">mm</span></p>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.1} className="space-y-5 lg:col-span-5">
            <p className="border-l-2 border-[var(--gold)] pl-5 text-sm leading-relaxed text-white" data-testid="intro-not-container">{i.notContainer}</p>
            <p className="pl-5 text-xs leading-relaxed text-[var(--steel-dim)]" data-testid="capacity-disclaimer">{i.capacityNote}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
